const commitHash = process.env.COMMIT

export const commitHashShort = commitHash?.substring(0, 7)

/**
 * A version which can be adjusted to include anything for display, such as
 * semantic versioning.
 */
export const displayVersion = `${commitHashShort}`
